import React from "react";
import { OrdersApi } from "./types";

export const OrdersContext = React.createContext<OrdersApi>({} as OrdersApi);
